import { Components } from "appworks/components/components";
import { State } from "appworks/state-machine/states/state";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { TGRFreespinIntroComponent } from "components/tgr-freespin-intro";
import { gameLayers } from "game-layers";

export class TGRAddQuickhitSymbolsToReels extends State {

    public onEnter(): void {
        new Sequence([
            () => Contract.wrap(() => gameLayers.FreespinsIntro.enableBoundsMask(true)),
            () => Components.get(TGRFreespinIntroComponent).enableReelHighlights(),
            () => Components.get(TGRFreespinIntroComponent).animateSymbolsSprites(),
            () => Components.get(TGRFreespinIntroComponent).disableReelHighlights()
        ]).then(() => this.complete());
    }
}
